/*
 * okd-cart-drawer.js
 * Eigene Warenkorb-/Printess-Anpassungen (ausgelagert aus snippets/cart-drawer.liquid).
 *
 * Enthält:
 *  1. Variantentausch im Drawer (cart-variant-select) inkl. Übernahme der
 *     Printess-Properties an die neue Variante.
 *  2. Automatisches Nachrüsten der "Bearbeiten"-Buttons nach AJAX-Rendering
 *     (MutationObserver am stabilen <cart-drawer>).
 *  3. Bearbeiten eines bestehenden Artikels ohne Printess-/cart-Redirect
 *     (Plugin-Hook doAllowReplaceBasketItemAsync).
 *
 * Hinweis: Als statische JS-Datei kein Liquid verfügbar – die Cart-URL wird
 * daher aus Shopify.routes.root abgeleitet (locale-/market-sicher).
 */
(function () {
  // Entspricht {{ routes.cart_url }} in Liquid, inkl. evtl. Sprach-/Market-Prefix.
  var CART_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';

  // Liest die (Printess-)Properties der Warenkorb-Zeile aus dem
  // data-cart-item-Attribut des Bearbeiten-Buttons in derselben Zeile.
  // Gibt null zurück, wenn es kein Printess-Artikel ist / keine Properties da sind.
  function getLineProperties(select, key) {
    const row = select.closest('tr.cart-item') ||
                select.closest('[id^="CartDrawer-Item-"]');
    if (!row) return null;

    const buttons = row.querySelectorAll('.printess-cart-integration-button[data-cart-item]');
    for (let i = 0; i < buttons.length; i++) {
      try {
        const data = JSON.parse(buttons[i].getAttribute('data-cart-item'));
        if (data && (!key || data.key === key)) {
          return (data.properties && Object.keys(data.properties).length)
            ? data.properties
            : null;
        }
      } catch (err) {
        console.warn('[cart-drawer] data-cart-item konnte nicht gelesen werden:', err);
      }
    }
    return null;
  }

  function swapCartVariant(select) {
    const newVariantId = parseInt(select.value);
    const key          = select.dataset.key;
    const quantity     = parseInt(select.dataset.quantity);

    select.disabled = true;

    // Basis-Payload; bei Printess-Artikeln die Properties der alten Zeile
    // an die neue Variante weiterreichen, damit die Gestaltung erhalten bleibt.
    const addBody = { id: newVariantId, quantity: quantity };
    const properties = getLineProperties(select, key);
    if (properties) {
      addBody.properties = properties;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addBody)
    })
    .then(() => fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }))
    .then(() => refreshCartDrawer(false))
    .catch(function (err) {
      console.error('[cart-drawer] Variantentausch fehlgeschlagen:', err);
    });
  }

  // Lädt die Drawer-Sektion + Cart-Bubble neu, rüstet die Printess-Buttons nach
  // und öffnet optional den Drawer. Wird sowohl vom Variantentausch als auch vom
  // Printess-Edit-Plugin verwendet.
  function refreshCartDrawer(openDrawer) {
    return fetch(CART_URL + '?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          const fresh   = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) current.replaceWith(fresh);
        });
        initPrintessCartButtons();
      })
      .then(() => fetch(CART_URL + '?section_id=cart-icon-bubble'))
      .then(r => r.text())
      .then(html => {
        const doc     = new DOMParser().parseFromString(html, 'text/html');
        const fresh   = doc.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(function () {
        if (!openDrawer) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        drawer.classList.remove('is-empty');
        const inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
      });
  }

  // --- Printess: neu gerenderte Warenkorb-Zeilen automatisch nachrüsten ---
  // Printess' initializeCartPage() läuft nur einmal beim Seitenaufbau. Wird der
  // Drawer per AJAX neu gerendert (Add-to-Cart oder Variantentausch), bleiben die
  // "Bearbeiten"-Buttons versteckt. Wir initialisieren neue Buttons daher selbst
  // über Printess' eigene initIntegrationButton()-Funktion.
  function initPrintessCartButtons() {
    if (typeof PrintessShopifyCartIntegration === 'undefined' ||
        typeof printessSettings === 'undefined') {
      return;
    }
    document
      .querySelectorAll('.printess-cart-integration-button:not([data-printess-attached])')
      .forEach(function (btn) {
        try {
          PrintessShopifyCartIntegration.initIntegrationButton(printessSettings, btn);
        } catch (err) {
          console.warn('[cart-drawer] Printess-Button konnte nicht initialisiert werden:', err);
        }
      });
  }

  // Der Inhalt von <cart-drawer> wird bei Add-to-Cart komplett ersetzt, das
  // Element selbst bleibt aber bestehen
  function observePrintessCartButtons() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.printessObserver === 'true') return;
    drawer.dataset.printessObserver = 'true';

    let scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        initPrintessCartButtons();
      });
    }).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('cart-variant-select')) {
      e.stopPropagation();
      swapCartVariant(e.target);
    }
  }, true);

  // --- Printess: Warenkorb-Artikel bearbeiten ohne /cart-Redirect ---
  // Nach dem Bearbeiten eines bestehenden Artikels leitet Printess hart auf /cart
  // um (window.location.replace in replaceBasketItem). Über den offiziellen
  // Plugin-Hook doAllowReplaceBasketItemAsync übernehmen wir den Austausch selbst
  // (neue Variante anlegen + alte Zeile entfernen), schließen den Editor, öffnen
  // den Drawer und geben false zurück – das unterdrückt den Redirect.
  function registerPrintessEditPlugin() {
    if (typeof registerPrintessPlugin !== 'function') return;

    registerPrintessPlugin({
      doAllowReplaceBasketItemAsync: function (context, params) {
        const oldKey     = new URLSearchParams(window.location.search).get('basketkey');
        const quantity   = parseInt(params && params.quantity) || 1;
        const properties = (params && params.properties) || {};

        let newVariantId = null;
        if (context && context.variant && typeof context.variant.getId === 'function') {
          newVariantId = parseInt(context.variant.getId());
        }
        // Fallback: Variante aus dem alten Key ("<variantId>:<hash>"), falls der
        // Editor keinen Varianten-Context liefert (Variante blieb unverändert).
        if ((!newVariantId || isNaN(newVariantId)) && oldKey) {
          newVariantId = parseInt(oldKey.split(':')[0]);
        }

        // Daten unvollständig → Printess-Standard (Redirect auf /cart) zulassen.
        if (!newVariantId || isNaN(newVariantId) || !oldKey) {
          return true;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newVariantId, quantity: quantity, properties: properties })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add fehlgeschlagen: ' + res.status);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: oldKey, quantity: 0 })
          });
        })
        .then(function () {
          // Printess-Editor schließen (offizielle API + DOM-Fallback)
          try {
            if (context.integration && context.integration.editor &&
                typeof context.integration.editor.hide === 'function') {
              context.integration.editor.hide();
            }
          } catch (e) { /* Fallback greift unten */ }
          const pc = document.querySelector('printess-component');
          if (pc) pc.style.display = 'none';
          document.documentElement.classList.remove('printess-editor-open');
          document.body.classList.remove('hideAll');

          return refreshCartDrawer(true);
        })
        .then(function () {
          return false; // Printess-Redirect auf /cart unterdrücken
        })
        .catch(function (err) {
          console.error('[printess-edit] Austausch fehlgeschlagen – Printess-Standard greift:', err);
          return true; // im Fehlerfall Printess normal weitermachen lassen
        });
      }
    });
  }

  observePrintessCartButtons();
  registerPrintessEditPlugin();
})();
